import React from 'react';
import { CloudImage } from '@components/CloudImage';
import { useSomethingBigController } from './SomethingBig.controllers';
import { WrapperBox, ArtBox, TextWrapperBox, StyledText } from './SomethingBig.styles';
import { useTranslation } from 'react-i18next';

export const SomethingBigDesktop: React.FC = () => {
  const { t } = useTranslation('careers');
  const somethingBigData = t('somethingBig');
  const { containerRef, assetsRef } = useSomethingBigController();
  return (
    <WrapperBox marginTop={12} ref={containerRef}>
      <CloudImage src={'careers/something-big/img.jpg'} height="100%" width="100%" />
      <ArtBox ref={assetsRef}>
        <CloudImage src={'careers/something-big/circle.svg'} width="100%" />
      </ArtBox>
      <TextWrapperBox>
        <StyledText color="yellow1" variant="hed120SuperEmphasis" tagName="h2">
          {somethingBigData.title}
        </StyledText>
      </TextWrapperBox>
    </WrapperBox>
  );
};
